import React from "react";
import { useChat } from "../context/ChatContext";
import "../styles/chat.css";

interface MessageInputProps {
  messageText: string;
  setMessageText: (text: string) => void;
  onSendMessage: () => void;
}

const MessageInput = ({ messageText, setMessageText, onSendMessage }: MessageInputProps) => {
  const { isConnected } = useChat();

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    // Send on Enter, allow Shift+Enter for new line
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSendMessage();
    }
  };

  return (
    <div className="input-container">
      <textarea
        className="message-input"
        disabled={!isConnected}
        placeholder={isConnected ? "Type message... (Enter to send, Shift+Enter for new line)" : "Connect first"}
        value={messageText}
        onChange={(e) => setMessageText(e.target.value)}
        onKeyDown={handleKeyDown}
        rows={4}
      />
    </div>
  );
};

export default MessageInput;
